import { useAtom } from '@reatom/npm-react'
import { AnimatePresence, motion } from 'motion/react'
import { useMemo } from 'react'
import { Link } from 'react-router'
import styled from 'styled-components'
import { match } from 'ts-pattern'

import { Platform, platformAtom } from '@root/entities/platform'
import { PlatformCircleIcon } from '@root/entities/platform/ui/platform-icon/platform-circle-icon'
import { FunExploreRoute } from '@root/features/routing'
import { TOPBAR_HEIGHT } from '@root/shared/ui-kit/utils/page-layout'

import { navigationExpandedAtom } from './atoms'

type Props = {}

export const SidebarPlatformLogo: React.FC<Props> = () => {
  const [platform] = useAtom(platformAtom)
  const [expanded] = useAtom(navigationExpandedAtom)

  const rootPath = useMemo(() => {
    return match(platform)
      .with(Platform.Pump, () => FunExploreRoute.build())
      .with(Platform.NFT, () => '/')
      .with(Platform.Terminal, () => '/')
      .with(Platform.Premium, () => '/premium')
      .exhaustive()
  }, [platform])

  const _renderAnimated = () => {
    return (
      <AnimatePresence initial={false} mode="popLayout">
        <Root
          key={platform}
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.9 }}
        >
          <Top as={Link} to={rootPath}>
            <PlatformCircleIcon size={30} platform={Platform.Terminal} />
            <Label aria-expanded={expanded}>kol.trade</Label>
          </Top>
        </Root>
      </AnimatePresence>
    )
  }

  return (
    <Root>
      <Top as={Link} to={rootPath}>
        <PlatformCircleIcon size={30} platform={Platform.Terminal} />
        <Label aria-expanded={expanded}>kol.trade</Label>
      </Top>
    </Root>
  )
}

const Root = styled(motion.div)``

const Top = styled.div`
  height: ${TOPBAR_HEIGHT}px;

  display: grid;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid var(--background-3);

  cursor: pointer;
  grid-template-columns: auto 1fr;
  padding-inline-start: 13px;
`

const Label = styled.div`
  color: var(--text-12);

  font-size: 14px;
  font-weight: 600;
  line-height: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  padding-inline-start: 10px;

  transition: opacity 0.1s ease-in-out;
  opacity: 0;

  &[aria-expanded='true'] {
    opacity: 1;
  }
`
